module.exports = __webpack_public_path__ + "img/fotos_pic_mobile_rus.1fc5dc7d.jpg";